import { TableCell, TableRow } from '@/components/ui/table'
import type { WebhookLog } from '@/lib/types'
import { EventDetailsDialog } from './event-details-dialog'
import { fromWebhookLog, EVENT_LABELS, PLATFORM_LABELS } from './event-constants'
import { StatusBadge } from './event-ui'

interface WebhookRowProps {
  webhook: WebhookLog
}

export function WebhookRow({ webhook }: WebhookRowProps) {
  const responseData = (webhook.response as { action?: string; reason?: string } | null) || {}
  const eventLabel = EVENT_LABELS[webhook.eventType || ''] || webhook.eventType || '-'
  const platformLabel = PLATFORM_LABELS[webhook.platform] || webhook.platform

  return (
    <TableRow>
      <TableCell className="text-sm text-muted-foreground">
        {new Date(webhook.createdAt).toLocaleString('pt-BR')}
      </TableCell>
      <TableCell className="capitalize">{platformLabel}</TableCell>
      <TableCell>{eventLabel}</TableCell>
      <TableCell>
        <StatusBadge status={webhook.status} />
      </TableCell>
      <TableCell>{responseData.action || '-'}</TableCell>
      <TableCell
        className="max-w-[200px] truncate text-muted-foreground"
        title={responseData.reason}
      >
        {responseData.reason || '-'}
      </TableCell>
      <TableCell>
        <EventDetailsDialog event={fromWebhookLog(webhook)} />
      </TableCell>
    </TableRow>
  )
}
